exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-selector-container {\n  height: 50px;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.view-color {\n  height: 30px;\n  width: 30px;\n  float: left;\n  margin-top: auto;\n  margin-bottom: auto;\n  margin-left: 10px;\n  margin-right: 10px;\n  text-align: center;\n\n  border-radius: 200px 200px 200px 200px;\n  -moz-border-radius: 200px 200px 200px 200px;\n  -webkit-border-radius: 200px 200px 200px 200px;\n  cursor: pointer;\n}\n\n.border {\n  border: solid 1px #525865;\n}\n.border .fa {\n  color: #949494 !important;\n}\n\n.view-color .fa {\n  color: #ffffff;\n  display: none;\n}\n\n.color-active {\n  height: 40px;\n  width: 40px;\n  padding-top: 6px;\n  margin-left: 5px;\n  margin-right: 5px;\n}\n\n.color-active .fa {\n  display: contents;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/color-selector/color-selector.component.css
// module id = ../../../../../src/app/components/color-selector/color-selector.component.css
// module chunks = main